import * as React from "react";
import Config from "../Config";

import '../styles/MainTypes.css';
import '../styles/ReportGenerator.css';

import ModalEntitySelection from "./modals/ModalEntitySelection";
import Loader from "./Loader.jsx";

export default class ReportGeneratorStep extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            selected: [],
            selectedPlain: []
        };

        this.aModalRef = React.createRef();
    }

    setSelected = () =>
    {
        if (!this.aModalRef.current)
        {
            return;
        }
        const aSelected = this.aModalRef.current.getSelected();
        if (!aSelected)
        {
            this.state.selected = [];
        }

        let aSelectedPlain = [];
        if (aSelected)
            if (!Array.isArray(aSelected))
            {
                const aSelectedValues = Object.values(aSelected);
                aSelectedValues.forEach(aVal =>
                {
                    if (Array.isArray(aVal))
                    {
                        aSelectedPlain = aSelectedPlain.concat(aVal);
                    }
                });
            } else
            {
                aSelectedPlain = aSelected;
            }

        this.setState({
            selected: aSelected,
            selectedPlain: aSelectedPlain
        });
    }

    getSelected = () =>
    {
        return this.state.selected;
    }

    clearSelection = () =>
    {
        this.setState({
            selected: [],
            selectedPlain: []
        });
    }

    render()
    {
        const sLabel = this.props.label;
        const sBtnLabel = this.props.btnLabel;
        const sListLabel = this.props.listLabel;
        const sContent = this.props.content;
        const bNoSelection = this.props.noSelection;
        const confirmCallback = this.props.confirmCallback;
        const bBtnDisabled = this.props.disableBtn;
        const bBtnAdditional = this.props.btnAdditional;
        const sBtnAdditionalLabel = this.props.btnAdditionalLabel;
        
        return (
            <div>
                <div className="MainTypes__sectionBordered">
                    <h3 className="ReportGenerator__label">{sLabel}</h3>
                    <button className="wrcButton ReportGenerator__btn" disabled={bBtnDisabled} onClick={() =>
                    {
                        if (bBtnDisabled)
                        {
                            return;
                        }
                        if (this.aModalRef.current)
                        {
                            this.aModalRef.current.toggleModal();
                        }
                        if (confirmCallback && "function" === typeof confirmCallback)
                        {
                            confirmCallback();
                        }
                    }}>
                        {sBtnLabel}
                    </button>
                    {
                        !bNoSelection ?
                            <div className="ReportGenerator__selections">
                                {
                                    (this.state.selectedPlain && 0 < this.state.selectedPlain.length) ?
                                        <label>{sListLabel}</label> :
                                        null
                                }
                                <ul>
                                    {
                                        this.state.selectedPlain && this.state.selectedPlain.slice(0, 5).map((aSelected) =>
                                            <li key={aSelected.name} className="ReportGenerator__listItem">{aSelected.name}</li>
                                        )
                                    }
                                    {
                                        (this.state.selectedPlain && 5 < this.state.selectedPlain.length) ?
                                            <li className="ReportGenerator__listItem">...</li> :
                                            null
                                    }
                                </ul>
                            </div> :
                            null
                    }
                    {
                        (bBtnAdditional && (this.state.selectedPlain && 0 < this.state.selectedPlain.length)) ?
                            <div>
                                <button className="wrcButton wrcButton--small2 ReportGenerator__btnAdditional" onClick={this.clearSelection}>
                                    {sBtnAdditionalLabel}
                                </button>
                            </div> :
                            null
                    }
                </div>
                {
                    !bNoSelection ?
                        <ModalEntitySelection
                            content={sContent}
                            ref={this.aModalRef}
                            rejectLabel={Config.strings.modals.reportGenerator.sRejectLabel}
                            confirmLabel={Config.strings.modals.reportGenerator.sConfirmLabel}
                            callback={this.setSelected}
                            selected={this.state.selected}
                        /> :
                        null
                }
            </div>
        );
    }
}